<template>
  <div>
    <div class="">
      <PageHeaderUI
        title="Account Statements"
        breadcrumb="Billings & Payments > My Transactions"
      />
    </div>
    <section class="bg-white my-4 p-3">
      <div class="flex border-b-2 border-gray-400 pt-2">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'wallet' }"
          @click="switchToWallet('wallet')"
        >
          <p>Wallet</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'card' }"
          @click="switchToWallet('card')"
        >
          <p>Card</p>
        </div>
      </div>

      <div class="flex py-4 justify-between">
        <div class="unit-point">
          <p class="w-full">
            No of Transactions: {{ transactions.totalCount || 0 }}
          </p>
          <span class="w-12">
            <img src="@/assets/images/billing/total_value.svg"/>
          </span>
        </div>
        <div class="unit-point">
          <p class="w-full">
            Total Value: ₦ {{ transactions.totalEarning || 0 }}
          </p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
      </div>


      <TableFilter
        v-if="routeName == 'account'"
        @setQueryparams="sortItemProps"
      />

      <KeepAlive>
        <div class="bg-white py-0 mt-8 mb-3" v-loading="isLoading">
          <component
            @fundWallet="showPaymentModal = true"
            @fundCard="fundCard"
            @setSubTab="setSubTab"
            :is="currentPage"
            :currentTab="currentTab"
            :withAction="false"
            :transactions="transactions.transactions || []"
          ></component>
        </div>
      </KeepAlive>

      <PaginationControl
        v-if="routeName == 'account'"
        :total="transactions.totalCount"
        :pageNumber="pageNumber"
        @pageNumber="setPageDisplay"
        @pageSize="setNumDisplay"
      />

      <PaymentModal
        @close-modal="showPaymentModal = false"
        :show-modal="showPaymentModal"
        :total="cardPaymentAmount"
        :paystackkey="paystackkey"
        @onCardPayment="onCardPayment"
      />
    </section>
  </div>
</template>

<script>
import TransactionTable from "@/components/Ondemand/Payments/TransactionTable";
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
import TableFilter from "@/components/Ondemand/Bookings/module/TableFilter.vue";
import Cards from "@/components/Ondemand/Payments/Cards.vue";
import AddCard from "@/components/Ondemand/Payments/AddCard.vue";
import PaginationControl from "@/components/UI/pagination";
import FundWallet from "@/components/Ondemand/Payments/modals/FundWallet.vue";
import PaymentModal from "@/components/Ondemand/Payments/modals/PaymentModal.vue";

export default {
  components: {
    TransactionTable,
    PageHeaderUI,
    TableFilter,
    Cards,
    AddCard,
    PaginationControl,
    FundWallet,
    PaymentModal,
  },
  computed: {
    routeName() {
      return this.$route.params?.name;
    },
    payload() {
      return {
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        payment_type: this.currentTab,
        searchTerm: this.sortOptions.searchString,
        startDate: this.sortOptions.startDate,
        endDate: this.sortOptions.endDate,

        customerType: "consumer",
      };
    },
    currentPage() {
      let tab;
      if (this.currentTab == "card" && this.routeName == "account") {
        tab = "transaction-table";
      } else if (this.currentTab == "wallet" && this.routeName == "account") {
        tab = "transaction-table";
      } else if (this.routeName == "view-cards") {
        tab = "cards";
      } else if (this.routeName == "add-card") {
        tab = "add-card";
      }
      return tab;
    },
  },
  watch: {
    payload() {
      this.getAccountStatement();
    },
  },
  mounted() {
    this.getAccountStatement();
  },
  methods: {
    switchToWallet(val) {
      switch (val) {
        case "wallet":
          this.currentTab = "wallet";
          this.$router.push({
            name: "AccountStatement",
            params: { name: "account" },
          });
          break;
        case "card":
          this.currentTab = "card";
          this.$router.push({
            name: "AccountStatement",
            params: { name: "account" },
          });
      }
    },
    viewCard() {
      this.$router.push({
        name: "AccountStatement",
        params: { name: "view-cards" },
      });
    },
    setSubTab(val) {
      this.subTabs = val;
    },
    setPageDisplay(val) {
      this.pageNumber = val;
    },
    setNumDisplay(val) {
      this.pageSize = val;
    },
    sortItemProps(val) {
      this.sortOptions = { ...this.sortOptions, ...val };
    },
    fundCard() {
      this.$router.push("/payments/account-statement/add-card");
    },
    fundWalletAction() {
      this.fundWallet = !this.fundWallet;
      this.currentTab = "Card";
    },
    async getAccountStatement() {
      this.isLoading = true;
      try {
        await this.$_getAccountStatement(this.payload).then((response) => {
          this.transactions = response.data.data;
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  data() {
    return {
      isLoading: false,
      showPaymentModal: false,
      currentTab: "wallet",
      subTabs: "active",
      fundWallet: true,
      transactions: [],
      showFundWallet: false,
      showFundSavedCard: false,
      transactionContent: {},
      pageSize: 10,
      pageNumber: 1,
      paystackkey: "pk_test_d81d41eedf44bac3067b59281f5aec31efc13049",
      sortOptions: {
        startDate: null,
        endDate: null,
        searchString: "",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.unit-point {
  @apply flex items-center shadow-lg px-4 py-2 rounded-lg;
  width: 48%;
}
.get-quote {
  @apply px-5 bg-primary-yellow py-3 rounded-md;
}
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>
